export const weekDaysTitle: Record<number, string> = {
  0: 'شنبه',
  1: 'یکشنبه',
  2: 'دوشنبه',
  3: 'سه‌شنبه',
  4: 'چهارشنبه',
  5: 'پنجشنبه',
  6: 'جمعه',
};

export const monthDaysTitle: Record<number, string> = {
  0: 'آخرین روز',
  1: 'یکم',
  2: 'دوم',
  3: 'سوم',
  4: 'چهارم',
  5: 'پنجم',
  6: 'ششم',
  7: 'هفتم',
  8: 'هشتم',
  9: 'نهم',
  10: 'دهم',
  11: 'یازدهم',
  12: 'دوازدهم',
  13: 'سیزدهم',
  14: 'چهاردهم',
  15: 'پانزدهم',
  16: 'شانزدهم',
  17: 'هفدهم',
  18: 'هجدهم',
  19: 'نوزدهم',
  20: 'بیستم',
  21: 'بیست و یکم',
  22: 'بیست و دوم',
  23: 'بیست و سوم',
  24: 'بیست و چهارم',
  25: 'بیست و پنجم',
  26: 'بیست و ششم',
  27: 'بیست و هفتم',
  28: 'بیست و هشتم',
  29: 'بیست و نهم',
  30: 'سی ام',
  31: 'سی و یکم',
};

// TODO: fix no-unused-vars for enums
/* eslint-disable no-unused-vars */
export enum AutoInvestDestination {
  Fund = 1,
  Hami = 2,
  HamiProfit = 3,
  HamiChild = 4,
  FundChild = 5,
}
